module.exports = __webpack_public_path__ + "ed6aa7a0c4277c4b783547d48005a23a.pdf";